import { render } from "./AddOnSurvey.vue?vue&type=template&id=61115755&scoped=true"
import script from "./AddOnSurvey.vue?vue&type=script&lang=js"
export * from "./AddOnSurvey.vue?vue&type=script&lang=js"

import "./AddOnSurvey.vue?vue&type=style&index=0&id=61115755&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61115755"]])

export default __exports__